"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AspectRatio = function AspectRatio(width, height) {
  return "\n  width: 100%;\n  padding-top: " + height / width * 100 + "%;\n";
};

exports.default = AspectRatio;